// extracted by mini-css-extract-plugin
module.exports = {"rotation":"PagebuilderTemplate_rotation__bGIoq"};